import React from 'react';
import {Button, Form, Row, Col, Select, Input} from 'antd';
import {actions, asyncList} from './reducers';
import {connect} from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const FormItem = Form.Item;

const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {

    constructor(props) {
        super(props);
    }

    handleReset = () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] === -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.asyncList();
    }

    add = () => {
        this.props.editShow();
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div>
                <h2 style={{marginBottom: '20px'}}>设备索引列表</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{marginBottom: '10px'}}>
                        <Col span={6}>
                            <FormItem {...spans} label="设备前缀名称">
                                {getFieldDecorator('devicePrefixNameLike')(<Input placeholder="请填写"
                                                                                  style={{width: '100%'}}/>)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="状态" {...spans}>
                                {getFieldDecorator('deviceIndexStatus')(
                                    <Select allowClear placeholder="全部" style={{width: 160}}>
                                        <Option key='0' value={0}>
                                            生成中
                                        </Option>
                                        <Option key='1' value={1}>
                                            完成
                                        </Option>
                                        <Option key='2' value={2}>
                                            删除索引数据
                                        </Option>
                                        <Option key='3' value={3}>
                                            停止
                                        </Option>
                                        <Option key='9' value={9}>
                                            异常
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{textAlign: 'right', marginTop: '10px', marginBottom: '20px'}}>
                            <Button  style={{margin: '0 8px'}} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" style={{margin: '0 8px'}} onClick={this.add}>
                                生成索引
                            </Button>
                            <Button type="primary" style={{margin: '0 8px'}} onClick={this.handleSearch}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({current: 1})),
    asyncList: () => dispatch(asyncList()),
    editShow: () => dispatch(actions.changeUiStatus({isUpdateShow: true})),
});

export default connect(null, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/assist/deviceIndex/search.js